import styled from "styled-components";

export const Container = styled.div`
  background: #edf5f7bf;
  height: 522px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  line-height: 1;

  h1 {
    margin: 0;
    font-size: 40px;
    font-weight: 400;
    font-family: "DM Serif Display", serif;
    padding-top: 114px;
    color: #2610c5;
  }

  h3 {
    margin: 10px 0 30px 0;
    font-size: 32px;
    color: #1d1956;
    font-weight: 400;
  }

  input {
    width: 45%;
    font-size: 16px;
    font-weight: 300;
    padding: 20px 30px;
    border: none;
    outline: none;
    box-shadow: 1px 1px 3px #aaaaaa;
    border-radius: 50px;
  }

  @media (max-width: 800px) {
    height: 440px;
    padding: 0 10%;

    h1 {
      font-size: 32px;
      line-height: 35px;
      padding-top: 108px;
    }

    h3 {
      font-size: 20px;
    }

    input {
      width: 85%;
    }
  }
`;

export const SecondContainer = styled.div`
  margin: 0;
  padding: 5% 0 0 0;
  text-align: center;
  line-height: 0.6;

  h1 {
    color: #2610c5;
    font-weight: 400;
    font-size: 36px;
    font-family: "DM Serif Display", serif;
  }

  h3 {
    font-family: Poppins;
    font-weight: 300;
    font-size: 24px;
    color: #2a2a2ad9;
  }

  hr {
    width: 6%;
    border: 2px solid #2610c5;
  }
  @media (max-width: 800px) {
    h1 {
      font-size: 24px;
    }
    h3 {
      font-size: 18px;
      font-weight: 400;
    }

    hr {
      width: 20%;
    }
  }
`;

export const SearchButton = styled.button`
  padding: 15px;
  margin: 30px 0;
  background: #2610c5;
  outline: none;
  width: 10%;
  color: white;
  border: none;
  font-weight: 300;
  border-radius: 50px;
  font-size: 16px;
  cursor: pointer;
  @media (max-width: 800px) {
    border-radius: 50px;
    width: 40%;
  }
`;

export const ImageOne = styled.img`
  position: absolute;
  top: 0;
  right: 73px;
  @media (max-width: 800px) {
    display: none;
  }
`;

export const ImageTwo = styled.img`
  position: absolute;
  bottom: -130px;
  left: 59px;
  width: 21%;
  @media (max-width: 800px) {
    display: none;
  }
`;

export const CircleOne = styled.img`
  position: absolute;
  top: 46px;
  left: 6%;
  @media (max-width: 800px) {
    top: 46px;
    left: 0%;
  }
`;
export const CircleTwo = styled.img`
  position: absolute;
  top: 26px;
  left: 8%;
  @media (max-width: 800px) {
    top: 29px;
    left: 4%;
  }
`;
export const CircleThree = styled.img`
  position: absolute;
  top: 66px;
  right: 5%;
  @media (max-width: 800px) {
    display: none;
  }
`;
export const CircleFour = styled.img`
  position: absolute;
  top: 26px;
  right: 1%;
  @media (max-width: 800px) {
    display: none;
  }
`;
export const CircleFive = styled.img`
  position: absolute;
  left: 37.8%;
  top: 102px;
  @media (max-width: 800px) {
    display: none;
  }
`;
